import { gsap, Power3 } from 'gsap'

function runSectionTitleAnimation(container)
{
  let line = container.find('.js-section-title-line-animation')
  let content = container.find('.js-section-title-content-animation')
  let contentDelay = 0
  if(line.length) {

    contentDelay = 0.25

    gsap.to(line, {
      "clip-path": "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
      duration: 1.5,
      ease: Power3.easeOut
    })

  }

  if(content.length) {
    gsap.to(content, {
      delay: contentDelay,
      opacity: 1,
      duration: 1
    })
  }

}

export { runSectionTitleAnimation }
